import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY, MID_GREY, SYSTEM_BLUE } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  lineStepper: {
    borderColor: `${theme.palette.primary.main} !important`,
    margin: theme.spacing(0, 4),
  },
  rootStepper: { width: "30%" },
  stackStepper: {
    borderBottomColor: MID_GREY,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    paddingBottom: theme.spacing(1),
  },
  rootAccordion: {
    backgroundColor: `${LIGHT_GREY} !important`,
    borderColor: MID_GREY,
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: `4px !important`,
  },
  imgStore: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    objectFit: "contain",
  },
  link: { color: SYSTEM_BLUE, cursor: "pointer", textDecoration: "underline" },
}));
